module.exports = __webpack_public_path__ + "credito-5-m-n3M.png";